









































































import { Component, Prop, Vue, Watch } from 'vue-property-decorator';
import { cloneDeep, differenceWith, isEqual } from 'lodash-es'
import { library } from '@fortawesome/fontawesome-svg-core';
import { faUtensils, faTrash, faSave, faTimes } from '@fortawesome/free-solid-svg-icons';
import constants from '@/utils/constants';
import { formatNumber } from '@/utils/helpers'

library.add(faUtensils, faTrash, faSave, faTimes);

@Component({
  filters: {
    formatPrice(val: any) {
      return formatNumber(val)
    },
  },
})
export default class MenuPopup extends Vue {
  @Prop({ default: false }) showModal?: boolean;
  @Prop() data!: any;

  $swal: any;
  orderItems: any[] = [];

  get updateOrderDetail() {
    return this.$store.getters.GetUpdateOrderDetail;
  }

  get listItems() {
    return this.orderItems.filter(item => item.quantity !== 0);
  }

  @Watch('updateOrderDetail.isSuccess')
  watchOrderDetailSuccess() {
    if (this.updateOrderDetail.isSuccess) {
      const payload = {
        orderId: this.data.orderId,
        orderDetails: this.listItems,
      };
      this.$store.commit('UPDATE_ORDER_DETAIL', payload);
      this.$emit('call-back', payload);
      this.$swal(
        constants.SUCCESS_MESSAGE,
        'Order Updated',
        constants.STATUS_SUCCESS
      );
    }
  }

  @Watch('updateOrderDetail.error')
  watchOrderDetailError() {
    if (this.updateOrderDetail.error) {
      this.$swal(
        constants.SOMETHING_WROING,
        this.updateOrderDetail.error,
        constants.STATUS_ERROR
      );
    }
  }

  reset() {
    this.orderItems = cloneDeep(this.data.orderDetails);
  }

  discardModal() {
    this.reset();
    this.$emit('discard-modal');
  }

  removeItem(index: number) {
    this.orderItems[index].quantity = 0;
  }

  updateQuantity(index: number, value: any) {
    if (value === '') {
      this.orderItems[index].quantity = '';
    } else if (Number(value) <= 0) {
      this.orderItems[index].quantity = 1;
    } else {
      this.orderItems[index].quantity = Number(value);
    }
  }

  saveData() {
    if (this.updateOrderDetail.isUpdating) return;
    this.$validator.validateAll().then(async(valid) => {
      if (valid) {
        const differentItems = differenceWith(this.orderItems, this.data.orderDetails, isEqual);
        this.$store.dispatch('UpdateOrderDetail', {
          orderId: this.data.orderId,
          menuItems: differentItems.map(item => ({
            menuItemCode: item.menuItemCode,
            quantity: item.quantity,
          })),
        });
      }
    });
  }
}
